import { PedidoSituacao, PedidoTipo } from './pedido';

// `GET aps://integracao/pedido/planilha?clienteid={id}`: historico de um cliente, anonimo.
// O `clienteid` e o `id` do `agente/cliente` e e obrigatorio - sem ele a resposta e 400.
export type PedidoPlanilhaCliente = {
  id: string;
  codigo: string;
  nome: string;
};

export type PedidoPlanilhaLinha = {
  id: string;
  codigo: string;
  situacao: PedidoSituacao;
  tipo: PedidoTipo;
  cliente: PedidoPlanilhaCliente;
  modelo: number;
  momento: string;
  total: number;
  pago: number;
  saldo: number;
};

export type PedidoPlanilha = {
  registros: number;
  linhas: number;
  pagina: number;
  paginas: number;
  lista: PedidoPlanilhaLinha[];
};

export const PEDIDO_PLANILHA_LINHAS = 30;

export function pedidoPlanilhaConsulta(clienteId: string, pagina: number = 1): string {
  return `aps://integracao/pedido/planilha?clienteid=${clienteId}`
    + `&linhas=${PEDIDO_PLANILHA_LINHAS}&pagina=${pagina}`;
}

export function pedidoPlanilhaLista(retorno: PedidoPlanilha): PedidoPlanilhaLinha[] {
  return Array.isArray(retorno?.lista) ? retorno.lista : [];
}
